const buildQuery = (
  fullName,
  jobTitle,
  city,
  state,
  streetAddress,
  postalCode,
  country,
  currentCompany,
  requiredFields,
  recordRecency,
  businessCategories,
  sourceURLs,
  orFields,
  // R33: New property ownership filters
  mostRecentPropertyPurchaseDate,
  propertiesOwnedDatePurchased,
  propertiesOwnedDateSold
) => {
  const { name: firstName, lastName } = fullName

  let queryParts = []

  if (firstName) {
    let nameQuery = `firstName:"${firstName}"`
    queryParts.push(nameQuery)
  }
  if (lastName) {
    let nameQuery = `lastName:"${lastName}"`
    queryParts.push(nameQuery)
  }

  if (jobTitle) {
    const titles = jobTitle
      .split(',')
      .map(title => title.trim())
      .filter(title => title !== '')
      .map(title => `"${title}"`)

    if (titles.length === 1) {
      queryParts.push(`jobTitle:${titles[0]}`)
    } else if (titles.length > 1) {
      queryParts.push(`jobTitle:(${titles.join(' OR ')})`)
    }
  }

  if (streetAddress) {
    queryParts.push(`address:"${streetAddress}"`)
  }

  if (city) {
    queryParts.push(`city:"${city}"`)
  }

  if (state) {
    queryParts.push(`province:"${state}"`)
  }

  if (postalCode) {
    queryParts.push(`postalCode:(${postalCode}*)`)
  }

  if (country) {
    queryParts.push(`country:"${country}"`)
  }

  if (currentCompany) {
    queryParts.push(`businessName:"${currentCompany}"`)
  }

  // Updated requiredFields handling with field mapping
  if (requiredFields) {
    const fieldMapping = {
      licensesType: 'licenses.type',
      licensesValue: 'licenses.value'
      // Add more mappings here if needed
    }

    requiredFields.forEach(field => {
      const mappedField = fieldMapping[field] || field
      queryParts.push(`${mappedField}:*`)
    })
  }

  if (businessCategories) {
    queryParts.push(`businessCategories:"${businessCategories}"`)
  }
  if (sourceURLs) {
    queryParts.push(`sourceURLs:"${sourceURLs}"`)
  }

  if (Array.isArray(orFields) && orFields.length === 2) {
    const [a, b] = orFields
    queryParts.push(`(${a}:* OR ${b}:*)`)
  }

  // Handle recordRecency
  if (recordRecency) {
    const { dateAdded, dateUpdated } = recordRecency

    if (dateAdded) {
      const dateAddedQuery = `dateAdded:[${dateAdded} TO *]`
      queryParts.push(dateAddedQuery)
    }

    if (dateUpdated) {
      const dateUpdatedQuery = `dateUpdated:[${dateUpdated} TO *]`
      queryParts.push(dateUpdatedQuery)
    }
  }

  // R33: Handle mostRecentPropertyPurchaseDate
  if (mostRecentPropertyPurchaseDate) {
    const { startDate, endDate } = mostRecentPropertyPurchaseDate

    if (startDate || endDate) {
      const start = startDate || '*'
      const end = endDate || '*'
      queryParts.push(`mostRecentPropertyPurchaseDate:[${start} TO ${end}]`)
    }
  }

  // R33: Handle propertiesOwnedHistory.datePurchased (nested field)
  if (propertiesOwnedDatePurchased) {
    const { startDate, endDate } = propertiesOwnedDatePurchased

    if (startDate || endDate) {
      const start = startDate || '*'
      const end = endDate || '*'
      queryParts.push(`propertiesOwnedHistory.datePurchased:[${start} TO ${end}]`)
    }
  }

  // R33: Handle propertiesOwnedHistory.dateSold (nested field with NOT operator)
  if (propertiesOwnedDateSold) {
    const { startDate, endDate, includeNotSold } = propertiesOwnedDateSold

    if (includeNotSold) {
      // Query for properties that have NOT been sold
      queryParts.push(`-propertiesOwnedHistory.dateSold:*`)
    } else if (startDate || endDate) {
      // Query for date range
      const start = startDate || '*'
      const end = endDate || '*'
      queryParts.push(`propertiesOwnedHistory.dateSold:[${start} TO ${end}]`)
    }
  }

  // Return the combined query or default if no parameters are set
  return queryParts.length > 0 ? queryParts.join(' AND ') : 'keys:*'
}

export default buildQuery
